import React from "react";
import styles from "./index.module.css";
import FeemonkText from "../../atoms/FeemonkText";

function Footer({ light }: { light?: boolean }) {
  if (light) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "1.25rem 1rem 1rem",
        gap: "0.6rem",
      }}>
        {/* Divider */}
        <div style={{ width: "100%", maxWidth: "400px", height: "1px", background: "rgba(255,255,255,0.1)", marginBottom: "0.25rem" }} />

        {/* Contact row */}
        <div style={{ display: "flex", alignItems: "center", gap: "1.5rem", flexWrap: "wrap", justifyContent: "center" }}>
          {/* Email */}
          <a href="mailto:hello@feemonk.com" style={{ display: "flex", alignItems: "center", gap: "0.45rem", textDecoration: "none" }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
              <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="rgba(255,255,255,0.6)" strokeWidth="1.6" strokeLinejoin="round" />
              <path d="M22 8L12 14L2 8" stroke="rgba(255,255,255,0.6)" strokeWidth="1.6" strokeLinejoin="round" />
            </svg>
            <span style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.65)", fontFamily: "Outfit, sans-serif" }}>hello@feemonk.com</span>
          </a>

          {/* Dot separator */}
          <div style={{ width: "3px", height: "3px", borderRadius: "50%", background: "rgba(255,255,255,0.2)" }} />

          {/* Phone */}
          <a href="tel:+916309631666" style={{ display: "flex", alignItems: "center", gap: "0.45rem", textDecoration: "none" }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="rgba(255,255,255,0.6)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.65)", fontFamily: "Outfit, sans-serif" }}>+91 95131 68846</span>
          </a>
        </div>

        {/* Copyright */}
        <p style={{ margin: 0, fontSize: "0.7rem", color: "rgba(255,255,255,0.35)", fontFamily: "Outfit, sans-serif", textAlign: "center" }}>
          Copyright © 2026 <FeemonkText light={light} /> All Rights Reserved.
        </p>
      </div>
    );
  }

  // Default (light background) footer — unchanged
  return (
    <div className={styles.footer}>
      <p className={styles.helpCenter}>Help centre</p>
      <div className={styles.contactDiv}>
        <span className={styles.contactItem}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
            <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="M22 8L12 14L2 8" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
          </svg>
          <p className={styles.mailText}>hello@feemonk.com</p>
        </span>
        <span className={styles.contactItem}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <p className={styles.contactNumber}>+91 95131 68846</p>
        </span>
      </div>
      <p className={styles.copyrightText}>
        Copyright © 2026 <FeemonkText /> All Rights Reserved.
      </p>
    </div>
  );
}

export default Footer;
